/**
 * @desc Yung-删除字典信息
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<string>;
export function request(id: number, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/dataDictionary/delete/${id}`, {
      method: "POST",

      ...options,
    }),
  );
}
